// @core/api/endpoints/chat/leave_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LeaveConversationRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Leave conversation
 * Removes the current user from the conversation. The user will no longer receive messages or notifications from this conversation.
 */
export async function LeaveConversation(
  conversation_id: string,
  data: LeaveConversationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/leave`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
